// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import close from "./../../assets/images/x.svg?url";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValue: ""
    };
    this.onFilterInput = this.onFilterInput.bind(this);
    this.close = this.close.bind(this);
  }

  onFilterInput(e) {
    e.persist();
    const rawValue = e.target.value;
    this.setState({ filterValue: rawValue });
    const trimmedValue = rawValue.trim();
    if (trimmedValue !== this.state.filterValue.trim()) {
      this.props.find(trimmedValue);
    }
  }

  close = () => {
    if (this.state.filterValue !== "") {
      this.setState({ filterValue: "" });
      this.props.find("");
    }
  };

  render() {
    return (
      <div
        className="project-tree-search"
        style={{ width: this.props.width ? this.props.width : "100%", borderRadius: "0" }}
      >
        <form className="search" onSubmit={event => event.preventDefault()}>
          <button className="form-submit" type="button">
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
          <input
            className="input-field"
            onInput={this.onFilterInput}
            onChange={this.onFilterInput}
            value={this.state.filterValue}
            placeholder={this.props.placeholder}
            type="text"
          />
          <a className="closes">
            <img src={close} onClick={this.close} style={{ pointerEvents: "all" }} alt="Close" />
          </a>
        </form>
      </div>
    );
  }
}

export default Search;
